const ids = [
    "ov-onskeskyen-generated-wish-button",
    "gowishRoundedButton",
    "gowishBlueButton",
    "gowishWhiteButton",
    "gowishDynamicButton",
  ];
  
  const SCRIPT_ID = "gowish-iframescript"; // script should be imported with this id
  const REGION_ATTR_NAME = "data-region"; // region attribute name - optional
  const PRODUCT_URL_ATTR_NAME = "data-producturl"; // product url attribute name - optional
  const ENV_ATTR_NAME = "data-env"; // dev, staging, prod
  const USE_BTN_REGION = "data-use-btn"; // use btn attribute name - optional
  const IFRAME_ID = "gowish-iframe"; // id iframe created by this script
  const DIALOG_ID = "gowish-iframe-dialog"; // id of dialog created by this script
  
  let isLoggingInWithSocial = false;
  
  // Adds click eventlistener for opening the iframe
  document.addEventListener("click", function (e) {
    if (e.target && e.target instanceof HTMLButtonElement) {
      const baseId = e.target.id.replace(/\d+$/, ''); // Remove numeric suffix
      if (ids.includes(baseId)) {
        const script = document.getElementById(SCRIPT_ID);
        const btn = document.getElementById(e.target.id);
        let region = "denmark";
        let targetUrl = undefined;
        if (script) {
          region = script.getAttribute(REGION_ATTR_NAME) || "denmark"; // fallback region is Denmark
        }
        if (btn && script) {
          if (script.getAttribute(USE_BTN_REGION)) {
            region = btn.getAttribute(REGION_ATTR_NAME) || "denmark"; // fallback region is Denmark
          }
          // Use product url as target url if defined
          const productUrl = btn.getAttribute(PRODUCT_URL_ATTR_NAME);
          if (productUrl && URL.canParse(productUrl)) {
            targetUrl = productUrl;
          }
        }
        createIframe(region, targetUrl);
      }
    }
  });
  
  // Adds message eventlistener for onClose
  window.addEventListener(
    "message",
    (event) => {
      if (event.data === "onClose") {
        const dialogElement = document.getElementById(DIALOG_ID);
        if (dialogElement) {
          document.body.removeChild(dialogElement);
        }
      }
    },
    false
  );
  
  // Returns iframe src url for a given region + encoded crawlertarget
  function getIframeSrc(region, encodedPath) {
    const script = document.getElementById(SCRIPT_ID);
    const env = script?.getAttribute(ENV_ATTR_NAME) ?? 'prod';
    let ROOT_DK = "https://onskeskyen.dk";
    let ROOT_NO = "https://onskeskyen.no";
    let ROOT_GLOBAL = "https://gowish.com";
  
    switch(env) {
      case "dev":
        ROOT_DK = "https://dev.onskeskyen.dk";
        ROOT_NO = "https://dev.onskeskyen.no";
        ROOT_GLOBAL = "https://dev.gowish.com";
        break;
      case "staging":
        ROOT_DK = "https://staging.onskeskyen.dk";
        ROOT_NO = "https://staging.onskeskyen.no";
        ROOT_GLOBAL = "https://staging.gowish.com";
        break;
    }
  
    const path = "/quick-add?source=button&crawlerTarget=" + encodedPath;
  
    switch (region) {
      case "global": return ROOT_GLOBAL + path;
      case "norway": return ROOT_NO + path;
      default: return ROOT_DK + path; // Defaults to Denmark
    }
  }
  
  // Creates the iframe
  async function createIframe(region, targetUrl) {
    try {
      // Construct encoded path for product
      const params = new URLSearchParams(window.location.search);
      const uri = targetUrl || params.get("crawlerTarget") || window.location.href;
      const encoded = encodeURIComponent(uri);
  
      // Check if this is a mobile device
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  
      if(isMobile) {
        let scheme = 'onskeskyen://';
        switch(region) {
          case "global":
            scheme = "gowish://";
            break;
          case "norway":
            scheme = "onskeskyen://";
            break;
        }
  
        const url = scheme + "quick-add?source=button&crawlerTarget=" + encoded;
        window.location.href = url;
  
        window.addEventListener("message", function(event) {
          const hasType = typeof event.data === 'object' && !!event.data && 'type' in event.data;
          const type = hasType && typeof event.data.type === 'string' ? event.data.type : undefined
          if (type === "gowish_iframe_open_popup") {
            const url = event.data.url;
            const authUrls = [
              'https://auth.gowish.com/',
              'https://auth.dev.gowish.com/',
              'https://auth.staging.gowish.com/'
            ]
  
            // Ensure url is auth url
            if(!authUrls.some(authUrl => url.startsWith(authUrl))) {
              return;
            }
  
            // Prevent closing iframe when returning to page
            isLoggingInWithSocial = true;
          }
        });
  
        // Close iframe if return to page
        document.addEventListener("visibilitychange", function() {
          if (document.visibilityState === 'visible') {
            if(isLoggingInWithSocial) {
              isLoggingInWithSocial = false;
              return;
            } else {
              const dialogElement = document.getElementById(DIALOG_ID);
              if (dialogElement) {
                document.body.removeChild(dialogElement);
              }
            }
          }
        });
      }
  
      const iframe = document.getElementById(IFRAME_ID);
      if (iframe) {
        // Close iframe if already opened
        const dialogElement = document.getElementById(DIALOG_ID);
        if (dialogElement) {
          document.body.removeChild(dialogElement);
        }
      } else {
        // Get iframe src
        const iframeSrc = getIframeSrc(region, encoded);
  
        // Create a modal
        const modal = document.createElement("dialog");
        modal.setAttribute("class", "gowish-dialog");
        modal.setAttribute("id", DIALOG_ID);
        modal.setAttribute(
          "style",
          "display:flex;justify-content:center;align-items:center;background-color:rgba(0, 153, 187, 0.45);border-width:0;min-width:100%;min-height:100%;width:100%;height:100%;text-align:center;"
        );
        modal.addEventListener("click", function () {
          const dialogElement = document.getElementById(DIALOG_ID);
          if (dialogElement) {
            document.body.removeChild(dialogElement);
          }
        });
  
        // Add iframe as a child to the modal
        modal.innerHTML = `
          <div id="modal-container" onclick="(e)=>{e.stopPropagation();e.preventDefault();}" class="gowish-modal-container" style="width:100%">
            <iframe
              id="${IFRAME_ID}"
              src="${iframeSrc}" 
              class="gowish-iframe"
              style="height:780px;border:none;margin:0 auto;padding:0;overflow:hidden;border-radius:30px;width:100%;max-width:824px;"
            />
          </div>
        `;
  
        // Append modal to the body
        document.body.appendChild(modal);
  
        // Show the modal
        const dialogElement = document.getElementById(DIALOG_ID);
        if (dialogElement instanceof HTMLDialogElement) {
          dialogElement.showModal();
        }
      }
    } catch (err) {
      console.error(err);
    }
  }